module.exports = __webpack_public_path__ + "static/media/post3.ebbdec1d.jpg";